
export default {
  path: 'results',
  name: 'event.discipline.results',
  component: () => import(/* webpackChunkName: "event" */ './results.vue'),
}
